import { useContext } from 'react';
import { ZakazkyContext } from '../services/zakazkyContext';

export const useZakazky = () => {
  const { zakazky } = useContext(ZakazkyContext);

  return { zakazky };
};
